import React from 'react';
import { Modal, Card } from 'semantic-ui-react';
import { paymentTypes } from '../data/payment-types';

export default ({ currentPlanIndex, onPeriodSelected }) => (
  <React.Fragment>
    <Modal.Header className="modal-header">Select a subscription period</Modal.Header>
    <Modal.Content>
      <h2 className="header-text blue-color">{paymentTypes[currentPlanIndex].title}</h2>
      <div className="period-select-container">
        <Card className="period-card" onClick={() => onPeriodSelected(true)}>
          <Card.Content>
            <h2 className="blue-color left-aligned">Annually</h2>
            <div className="annual-period-card">
              <p className="annual-period-card-first">
                {paymentTypes[currentPlanIndex].annual.description}
              </p>
              <h3 className="green-color annual-period-card-second">
                SAVE ${paymentTypes[currentPlanIndex].monthly.price * 2}
              </h3>
            </div>
            <p className="left-aligned body-text">
              Billed as one payment of ${paymentTypes[currentPlanIndex].annual.price}
            </p>
          </Card.Content>
        </Card>
      </div>
      <div className="period-select-container">
        <Card className="period-card" onClick={() => onPeriodSelected(false)}>
          <Card.Content>
            <div className="annual-period-card-first">
              <h2 className="blue-color">Monthly</h2>
              <p>{paymentTypes[currentPlanIndex].monthly.description}</p>
            </div>
          </Card.Content>
        </Card>
      </div>
    </Modal.Content>
  </React.Fragment>
);
